module.exports = __webpack_public_path__ + "product/product-step-plain@2x-4f64e8d7b4fc8897a9358dd5fa74a603.png";